/*
  Dabi Deri — kampanya merkezi.

  Yüzen düğme → tam ekran sahne: ortada madalyon (görseller akar), etrafında
  çember halinde kampanya kartları. Karta tıklanınca ayrıntı (şablon
  klonlanır) sahneye gelir; geri dönülür. Geri sayımlar, kod kopyalama,
  kaydırma kilidi, Esc, odak yönetimi burada.

  Diğer modüller `dabi:campaigns:open` olayıyla (detail.id isteğe bağlı)
  sahneyi açabilir; kampanya verisi window.DabiCampaigns'te.
*/
(() => {
  const dataEl = document.querySelector('[data-dabi-campaigns]');
  try {
    window.DabiCampaigns = dataEl ? JSON.parse(dataEl.textContent) : [];
  } catch (err) {
    window.DabiCampaigns = [];
  }
  document.dispatchEvent(new CustomEvent('dabi:campaigns:ready'));

  /* ---------- ürün sayfası kampanya şeridi ---------- */
  const productStrip = () => {
    const host = document.querySelector('[data-dabi-product-campaign]');
    if (!host || host.dataset.ready === 'true') return;
    host.dataset.ready = 'true';
    const list = window.DabiCampaigns || [];
    const tags = (host.dataset.tags || '').split(',').map((t) => t.trim().toLowerCase()).filter(Boolean);
    const type = (host.dataset.type || '').trim().toLowerCase();
    const handle = host.dataset.handle;
    const hits = list.filter((c) => c.all
      || (c.handles || []).includes(handle)
      || (c.tags || []).map((t) => String(t).trim().toLowerCase()).filter(Boolean).some((t) => tags.includes(t))
      || (type && (c.types || []).map((t) => String(t).trim().toLowerCase()).includes(type)))
      .slice(0, Number(host.dataset.max) || 2);
    if (hits.length === 0) return;
    host.innerHTML = '';
    hits.forEach((c) => {
      const row = document.createElement('div');
      row.className = 'dabi-pcamp__row';
      row.innerHTML = `<span class="dabi-pcamp__badge">${c.badge || host.dataset.label || ''}</span>`
        + `<span class="dabi-pcamp__body"><strong>${c.title || ''}</strong>${c.short ? `<span class="dabi-pcamp__short">${c.short}</span>` : ''}</span>`
        + (c.code ? `<button type="button" class="dabi-pcamp__code" data-code="${c.code}"><small>${host.dataset.labelCode || ''}</small> ${c.code}</button>` : '')
        + `<button type="button" class="dabi-pcamp__more" data-id="${c.id}">${host.dataset.labelDetail || ''}</button>`;
      const codeBtn = row.querySelector('.dabi-pcamp__code');
      if (codeBtn) codeBtn.addEventListener('click', async (e) => {
        const b = e.currentTarget;
        try { await navigator.clipboard.writeText(b.dataset.code); b.classList.add('is-copied'); window.setTimeout(() => b.classList.remove('is-copied'), 1600); } catch (err) { /* pano yok */ }
      });
      row.querySelector('.dabi-pcamp__more').addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('dabi:campaigns:open', { detail: { id: c.id } }));
      });
      host.appendChild(row);
    });
    host.hidden = false;
  };
  productStrip();
  document.addEventListener('shopify:section:load', productStrip);

  const root = document.querySelector('[data-dabi-camphub]');
  if (!root) return;

  const trigger = root.querySelector('[data-camphub-open]');
  const overlay = root.querySelector('[data-camphub-overlay]');
  const ring = root.querySelector('[data-camphub-ring]');
  const detail = root.querySelector('[data-camphub-detail]');
  const coreMedia = root.querySelector('[data-camphub-core-media]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const cycleMs = Math.max(800, (parseFloat(getComputedStyle(root).getPropertyValue('--dabi-ch-cycle')) || 2) * 1000);

  let open = false;
  let lastFocus = null;
  let coreTimer = null;
  let detailTimer = null;
  let tickTimer = null;

  /* ---------- yay açıları ----------
     Kartlar düğmenin etrafında, ekranın içine dönük bir yay üzerinde. Konuma
     göre yayın ortası: sağ üst → aşağı-sol, sol üst → aşağı-sağ, vb.
     0° = sağ, 90° = aşağı (ekran koordinatı). */
  const fanCenter = { 'header-right': 150, 'header-left': 30, 'right-middle': 180, 'left-middle': 0, 'right-bottom': 225, 'left-bottom': 315 };
  const layoutFan = () => {
    const cards = Array.from(root.querySelectorAll('[data-camphub-card]'));
    const n = cards.length;
    if (!n) return;
    const spread = Math.min(Number(root.dataset.spread) || 120, n === 1 ? 0 : 200);
    const center = fanCenter[root.dataset.position] ?? 150;
    const start = center - spread / 2;
    const step = n > 1 ? spread / (n - 1) : 0;
    // Kart genişliği ~18rem; komşular çakışmasın diye yarıçap gerekirse büyür.
    const cardW = (cards[0].offsetWidth || 180) + 12;
    const need = n > 1 ? cardW / (2 * Math.sin((step * Math.PI) / 360)) : 0;
    const r = Math.max(Number(root.dataset.radius) || 230, Math.min(need, window.innerWidth * 0.45));
    root.style.setProperty('--dabi-ch-r', `${r}px`);
    cards.forEach((c, i) => {
      const a = n === 1 ? center : start + i * step;
      c.style.setProperty('--a', `${a}deg`);
      c.style.setProperty('--i', String(i));
      c.style.setProperty('--row', String(i)); // mobil liste sırası
    });
  };

  /* ---------- görsel döngüsü ---------- */
  const cycle = (box, ms) => {
    const frames = box ? Array.from(box.querySelectorAll('.dabi-camphub__frame')) : [];
    if (frames.length < 2 || reduceMotion.matches) {
      if (frames[0]) frames[0].classList.add('is-active');
      return null;
    }
    let i = frames.findIndex((f) => f.classList.contains('is-active'));
    if (i < 0) { i = 0; frames[0].classList.add('is-active'); }
    return window.setInterval(() => {
      frames[i].classList.remove('is-active');
      i = (i + 1) % frames.length;
      frames[i].classList.add('is-active');
      box.dispatchEvent(new CustomEvent('dabi:frame', { detail: { index: i } }));
    }, ms);
  };

  /* ---------- geri sayım ---------- */
  const tick = () => {
    root.querySelectorAll('[data-ends]').forEach((el) => {
      const ends = Date.parse(el.dataset.ends.replace(' ', 'T'));
      const timer = el.querySelector('[data-camphub-timer]');
      if (!timer || Number.isNaN(ends)) return;
      const left = ends - Date.now();
      if (left <= 0) { timer.hidden = true; return; }
      const d = Math.floor(left / 86400000);
      const h = Math.floor((left % 86400000) / 3600000);
      const m = Math.floor((left % 3600000) / 60000);
      const set = (u, v) => { const n = timer.querySelector(`[data-unit="${u}"]`); if (n) n.textContent = String(v); };
      set('d', d); set('h', h); set('m', m);
      timer.hidden = false;
    });
  };

  /* ---------- aç / kapa ---------- */
  const showRing = () => {
    root.classList.remove('is-detail');
    detail.hidden = true;
    detail.innerHTML = '';
    if (detailTimer) { clearInterval(detailTimer); detailTimer = null; }
    ring.hidden = false;
    if (!coreTimer) coreTimer = cycle(coreMedia, cycleMs);
  };

  const showDetail = (id) => {
    const tpl = root.querySelector(`[data-camphub-tpl="${CSS.escape(id)}"]`);
    if (!tpl) return;
    detail.innerHTML = '';
    detail.appendChild(tpl.content.cloneNode(true));
    detail.hidden = false;
    root.classList.add('is-detail');
    if (coreTimer) { clearInterval(coreTimer); coreTimer = null; }
    const media = detail.querySelector('[data-camphub-d-media]');
    const products = Array.from(detail.querySelectorAll('[data-camphub-product]'));
    const hasImage = media && media.querySelector('.dabi-camphub__frame.is-active');
    detailTimer = cycle(media, cycleMs + 400);
    // Görsel değişince ilgili ürün vurgulanır (ilk kare kampanya görseliyse kaydırılır).
    media?.addEventListener('dabi:frame', (e) => {
      const offset = hasImage ? 1 : 0;
      products.forEach((p, i) => p.classList.toggle('is-active', i === e.detail.index - offset));
    });
    products.forEach((p) => {
      p.addEventListener('pointerenter', () => {
        const frames = media ? Array.from(media.querySelectorAll('.dabi-camphub__frame')) : [];
        const offset = hasImage ? 1 : 0;
        const target = frames[Number(p.dataset.camphubProduct) + offset];
        if (!target) return;
        frames.forEach((f) => f.classList.toggle('is-active', f === target));
        products.forEach((q) => q.classList.toggle('is-active', q === p));
      });
    });
    detail.querySelector('[data-camphub-back]')?.addEventListener('click', showRing);
    // Sepete ekle / hemen al: Craft sepet çekmecesi güncellenir, hemen al ödemeye gider.
    const msg = detail.querySelector('[data-camphub-msg]');
    const say = (text, bad) => { if (!msg) return; msg.textContent = text; msg.hidden = false; msg.classList.toggle('is-bad', !!bad); };
    const addVariant = async (id) => {
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = new FormData();
      body.append('id', id);
      body.append('quantity', 1);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.append('sections', cart.getSectionsToRender().map((s) => s.id));
        body.append('sections_url', window.location.pathname);
      }
      const url = (window.routes && window.routes.cart_add_url) || `${root.dataset.root || '/'}cart/add.js`;
      const res = await fetch(url, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body });
      const data = await res.json();
      if (data.status) throw new Error(data.description || data.message);
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'dabi-campaign-hub', productVariantId: String(id), cartData: data });
      }
      if (cart && typeof cart.renderContents === 'function') {
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(data);
      }
      return data;
    };
    detail.querySelectorAll('[data-camphub-add]').forEach((b) => {
      b.addEventListener('click', async () => {
        b.disabled = true;
        try { await addVariant(b.dataset.camphubAdd); say(root.dataset.labelAdded); b.classList.add('is-done'); }
        catch (err) { say(root.dataset.labelError, true); }
        b.disabled = false;
      });
    });
    detail.querySelectorAll('[data-camphub-buy]').forEach((b) => {
      b.addEventListener('click', async () => {
        b.disabled = true;
        try { await addVariant(b.dataset.camphubBuy); window.location.assign(`${root.dataset.root || '/'}checkout`); }
        catch (err) { say(root.dataset.labelError, true); b.disabled = false; }
      });
    });
    detail.querySelector('[data-camphub-code]')?.addEventListener('click', async (e) => {
      const b = e.currentTarget;
      try { await navigator.clipboard.writeText(b.dataset.camphubCode); } catch (err) { /* pano yok */ }
      const label = b.querySelector('.dabi-camphub__code-label');
      const old = label.textContent;
      label.textContent = b.dataset.copied || old;
      b.classList.add('is-copied');
      window.setTimeout(() => { label.textContent = old; b.classList.remove('is-copied'); }, 2000);
    });
    tick();
    detail.focus({ preventScroll: true });
  };

  const openHub = (id) => {
    if (open) { if (id) showDetail(id); return; }
    open = true;
    lastFocus = document.activeElement;
    overlay.hidden = false;
    layoutFan();
    // Konum yerleşsin, sonra açılış geçişi oynasın.
    window.requestAnimationFrame(() => root.classList.add('is-open'));
    root.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    showRing();
    tick();
    tickTimer = window.setInterval(tick, 30000);
    if (id) showDetail(id);
    else root.querySelector('[data-camphub-close]')?.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('dabi:campaigns:opened'));
  };

  const closeHub = () => {
    if (!open) return;
    open = false;
    root.classList.remove('is-open');
    root.classList.add('is-closing');
    trigger.setAttribute('aria-expanded', 'false');
    if (coreTimer) { clearInterval(coreTimer); coreTimer = null; }
    if (detailTimer) { clearInterval(detailTimer); detailTimer = null; }
    if (tickTimer) { clearInterval(tickTimer); tickTimer = null; }
    const done = () => {
      root.classList.remove('is-closing', 'is-detail');
      overlay.hidden = true;
      (lastFocus || trigger).focus?.({ preventScroll: true });
    };
    if (reduceMotion.matches) done();
    else window.setTimeout(done, 320);
  };

  // Açık sahne yalnız çarpıyla kapanır (dışa tıklama / Esc kapatmaz).
  trigger.addEventListener('click', () => { if (!open) openHub(); });
  root.querySelectorAll('[data-camphub-close]').forEach((b) => b.addEventListener('click', closeHub));
  root.querySelectorAll('[data-camphub-card]').forEach((c) => c.addEventListener('click', () => showDetail(c.dataset.camphubCard)));
  document.addEventListener('keydown', (e) => {
    if (!open) return;
    if (e.key === 'Escape' && root.classList.contains('is-detail')) showRing();
  });
  window.addEventListener('resize', () => { if (open) layoutFan(); }, { passive: true });
  document.addEventListener('dabi:campaigns:open', (e) => openHub(e.detail && e.detail.id));

  // Kart geri sayımları sahne kapalıyken de doğru dursun (açılışta anında).
  tick();

  // Düğme ilk görünüşte dikkat çeksin, sonra sakinleşsin.
  window.setTimeout(() => root.classList.add('is-settled'), 6000);
})();
